import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bdb774e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outcome-modal-header text-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "button-container" }

import { ref } from "vue";
import { Modal } from "uiv";
import { CmsGoalData } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'outcome-modal',
  props: {
    outcomeUid: {},
    outcome: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const isModalOpen = ref(false);
const route = useRoute();

function openModal(): void {
  isModalOpen.value = true;
}

function closeModal(): void {
  isModalOpen.value = false;
}

__expose({ openModal, closeModal });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.outcome)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: isModalOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
        "append-to-body": true,
        footer: false,
        header: false,
        class: "outcome-modal",
        "data-test": "outcome-modal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "btn-close-sm",
              onClick: closeModal,
              type: "button"
            }),
            _createElementVNode("img", {
              src: _ctx.outcome.image.url,
              alt: _unref(cms).asText(_ctx.outcome.name),
              class: "outcome-modal-image",
              "data-test": "outcome-modal-img"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", {
              innerHTML: _unref(cms).asHtml(_ctx.outcome.full_title),
              class: "outcome-full-title",
              "data-test": "outcome-modal-title"
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", {
            innerHTML: _unref(cms).asHtml(_ctx.outcome.brief_description),
            class: "outcome-desc",
            "data-test": "outcome-modal-desc"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: `outcome/${_ctx.outcomeUid}/select${_unref(route).query.asaccredited ? `?asaccredited=${_unref(route).query.asaccredited}` : ''}`,
              class: "btn btn-primary",
              "data-test": "outcome-modal-next"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Next")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})